import { IMenuHistoryState } from './types';

const state: IMenuHistoryState = {
  items: [],
  selectedResultIndex: -1,
  cacheSuffix: '',
  mustHaveCacheSuffix: true,
};

export default state;
